// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1oazR","choiceBoxes":"toolbarselects_choiceBoxes__3K3a0","simpleField":"toolbarselects_simpleField__cNLoO"};